import { render, staticRenderFns } from "./PurchaseInvoiceReport.vue?vue&type=template&id=e2ff474e&scoped=true&"
import script from "./PurchaseInvoiceReport.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoiceReport.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInvoiceReport.vue?vue&type=style&index=0&id=e2ff474e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ff474e",
  null
  
)

export default component.exports